import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from 'src/app/core/shared/config/config';
import { AuthStateService } from './auth-state-service';
import { environment } from 'src/environments/environment';
import { TokenService } from '../services/tokenservice/token.service';

const CODE_VERIFIER_KEY = 'code_verifier';
const TOKEN_KEY = 'token';
const REFRESH_TOKEN = 'refresh_token';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private govLogoutUrl = environment.govLogoutUrl;
  private config: Config;
  private isLogginOut = false;

  constructor(
    private router: Router,
    private authStateService: AuthStateService,
    private tokenService: TokenService
  ) {
    this.config = new Config();
  }

  public logout(option: string): void {
    if (this.isLogginOut) {
      console.warn('[LogoutService]Logou já em andamento. Ignorando nova tentativa.')
      return
    }
    this.isLogginOut = true;

    const method = this.authStateService.getAuthMethod();
    this.clearTokens();

    if (method === 'gov') {
      const logoutUrl = `${this.govLogoutUrl}?post_logout_redirect_uri=${encodeURIComponent(environment.redirectUrlLogoutGOVBR)}`;
      window.location.href = logoutUrl;
    } else if (method === 'ping') {
      let logoutUrl = `${this.config.url_base}/idp/startSLO.ping`;

      if (option) {
        logoutUrl += `?action=${option}`;
      }

      setTimeout(() => {
        window.location.href = logoutUrl;
      }, 100);
    } else {
      this.router.navigate(['/home']);
    }
  }

  private clearTokens(): void {
    const storageKeys = [
      TOKEN_KEY,
      CODE_VERIFIER_KEY,
      REFRESH_TOKEN
    ];

    storageKeys.forEach(key => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });

    this.tokenService.clearTokens();
    this.authStateService.clearAuthMethod();
  }
}
